export default __webpack_public_path__ + "static/media/dot.b9e47a8d.svg";